


import { Component, Vue } from 'vue-property-decorator';

import Ship from '@/shared/components/ship.component.vue';
import ExpansionPanel from '@/shared/components/expansion.panel.component.vue';

@Component({
  components: {
    Ship,
    ExpansionPanel,
  },
})
export default class PartialShip extends Vue {
  private chipState1 = true;
  private chipState2 = false;
}
